import { Component, input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { YoutubeThumbnail } from '../../services/youtube.service';
import { formatViews, formatUploadedDate, formatDuration } from '../../utils';

@Component({
  selector: 'youtube-thumbnail',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './youtube-thumbnail.component.html',
  styleUrls: ['./youtube-thumbnail.component.scss'],
})
export class YoutubeThumbnailComponent {
  video = input.required<YoutubeThumbnail>();
  isDesktop = input(false);
  formatViews = formatViews;
  formatUploadedDate = formatUploadedDate;
  formatDuration = formatDuration;
}
